import * as types from "../types/internetStatus"

const initialState = {
  online: true,
  forceOffline: false
}

const internetStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INTERNET_STATUS:
      return {
        ...state,
        online: action.isOnline
      }
    case types.SET_FORCE_OFFLINE:
      return {
        ...state,
        forceOffline: true
      }
    case types.REMOVE_FORCE_OFFLINE:
      return {
        ...state,
        forceOffline: false
      }
    default:
      return state
  }
}

export default internetStatusReducer